var Scrim   = require("enyo-ui/Scrim"),
    Spinner = require("app/ui/Spinner"),
    kind    = require("enyo/kind");

require("./LoaderView.less");

module.exports = kind(/** @lends  app.MediaPlayer.LoaderView.prototype */ {

    /**
     * @private
     */
    name: "app.MediaPlayer.LoaderView",

    /**
     * @private
     */
    classes: "app-media-player-loader-view enyo-fit",

    /**
     * @private
     */
    components: [{
        name:           "innerScrim",
        kind:           Scrim,
        floating:       false,
        classes:        "app-media-player-loader-view__inner-scrim app-ui-scrim",
        showing:        true,
        initialOpacity: 1
    }, {
        name:           "spinner",
        kind:           Spinner,
        classes:        "app-media-player-loader-view__spinner",
        showing:        true,
        initialOpacity: 1
    }]

});
